import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

// 淡入动画
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// 淡出动画
const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-10px);
  }
`;

// 过渡容器 - 使用 $ 前缀避免属性传递到 DOM
const TransitionContainer = styled.div<{ $isVisible: boolean; $duration: number }>`
  width: 100%;
  height: 100%;
  animation: ${props => props.$isVisible ? fadeIn : fadeOut} ${props => props.$duration}ms ease-out;
  animation-fill-mode: both;
`;

interface PageTransitionProps {
  /**
   * 子组件
   */
  children: React.ReactNode;
  /**
   * 过渡持续时间（毫秒），默认 300ms
   */
  duration?: number;
  /**
   * 延迟时间（毫秒），默认 0ms
   */
  delay?: number;
  /**
   * 是否启用过渡动画，默认 true
   */
  enabled?: boolean;
}

/**
 * 页面过渡组件
 * 为页面切换提供流畅的过渡动画
 */
const PageTransition: React.FC<PageTransitionProps> = ({
  children,
  duration = 300,
  delay = 0,
  enabled = true,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setIsVisible(true);
      return;
    }

    // 延迟显示动画
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay, enabled]);

  if (!enabled) {
    return <>{children}</>;
  }

  return (
    <TransitionContainer $isVisible={isVisible} $duration={duration}>
      {children}
    </TransitionContainer>
  );
};

export default PageTransition;
